<template>
  <section id="page-dilivery" class="page-dilivery w-100">
    <b-modal v-if="modalDilivery && !checkIsEmpty()" v-model="modalDilivery" size="lg" centered hide-header hide-footer no-close-on-backdrop id="model-add-dilivery-method-pos">
      <div class="head-popup-payment-method">
        <button type="button" aria-label="Close" class="close close-ext font-weight-light" @click="$emit('clickModalDiliveryHide')">×</button>
        <div class="text-title-modal text-bold fz-18">Thêm thông tin giao hàng</div>
      </div>
      <div class="content-popup-dilivery-method">
        <div class="row">
          <div class="col-md-4">
            <div class="title-dilivery">
              <img src="@/assets/images/icon-dilivery/bx-current-location-1.svg" />
              ĐỊA CHỈ LẤY HÀNG
            </div>
            <div class="box-get-dilivery">
              <div>{{dloInfoTmp.pickUpAddress.storeName}}</div>
              <div>{{dloInfoTmp.pickUpAddress.address}}</div>
            </div>
            <div class="title-dilivery">
              <img src="@/assets/images/icon-dilivery/ic-pin-drop-1.svg" />
              ĐỊA CHỈ GIAO HÀNG
            </div>
            <div>
              <div><input v-model="dloInfoTmp.shippingAddress.receiverName" placeholder="Tên người nhận *" class="input-dilivery" :class="{'_errors': arrErrors.receiverName}"></div>
              <div><input v-model="dloInfoTmp.shippingAddress.phoneNo" @keypress="checkNum($event)" placeholder="Số điện thoại *"  class="input-dilivery" :class="{'_errors': arrErrors.phoneNo}"></div>
              <div class="mb-3">
                  <el-select
                    @change="getListDistrictHere()"
                    class="w-100"
                    v-model="dloInfoTmp.shippingAddress.city" 
                    placeholder="Tỉnh/Thành phố"
                    :class="{'errors': arrErrors.city}"
                    filterable
                    :filter-method="(query)=>filterOption(query, this, 'listCity', 'listCityFilter')"
                    @visible-change="(visible) => visible && filterOption('', this, 'listCity', 'listCityFilter')"
                    >
                    <el-option
                      v-for="item in listCityFilter"
                      :key="item.id"
                      :label="item.text"
                      :value="item.id">
                    </el-option>
                  </el-select>
              </div>
              <div class="item-row mb-3">
                <div class="item-dilivery-50">
                    <el-select
                      ref="districtRef"
                      @change="getListWardHere()"
                      class="w-100"
                      v-model="dloInfoTmp.shippingAddress.district" 
                      placeholder="Quận/Huyện"
                      :class="{'errors': arrErrors.district}"
                      filterable
                      :filter-method="(query)=>filterOption(query, this, 'listDistrict', 'listDistrictFilter')"
                      @visible-change="(visible) => visible && filterOption('', this, 'listDistrict', 'listDistrictFilter')"
                      >
                      <el-option
                        v-for="item in listDistrictFilter"
                        :key="item.id"
                        :label="item.text"
                        :value="item.id">
                      </el-option>
                    </el-select>
                </div>
                <div class="item-dilivery-50">
                  <el-select
                    ref="wardRef"
                    @change="changeWardHere()"
                    class="w-100"
                    v-model="dloInfoTmp.shippingAddress.village" 
                    placeholder="Phường/Xã"
                    :class="{'errors': arrErrors.village}"
                    filterable
                    :filter-method="(query)=>filterOption(query, this, 'listWard', 'listWardFilter')"
                    @visible-change="(visible) => visible && filterOption('', this, 'listWard', 'listWardFilter')"
                    >
                    <el-option
                      v-for="item in listWardFilter"
                      :key="item.id"
                      :label="item.text"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="mt-2"><input type="text" v-model="dloInfoTmp.shippingAddress.address" placeholder="Địa chỉ cụ thể *" class="input-dilivery mb-0" :class="{'_errors': arrErrors.address}" @input="getValWard"></div>
            </div>
            <div v-if="dloInfoTmp.targetService == 'DELIVERY_PARTNER'">
              <div class="title-dilivery mt-3">
                <img style="position: relative; top: -2px;" src="@/assets/images/icon-dilivery/money-bill.svg" />
                DỰ KIẾN TIỀN THU HỘ (COD)
              </div>
              <div>
                <div>
                  <number v-model.number="dloInfoTmp.cod" v-bind="numFormat" 
                  @change="callChangeDataAppCode" placeholder="Số tiền thu hộ"
                  @keydown.native="enterKeyMinus($event)"
                  class="input-dilivery mb-0" :class="{'_errors': arrErrors.cod}"/>
                </div>
              </div>
              <div class="title-dilivery mt-3">
                <img style="position: relative; top: -2px;" src="@/assets/images/icon-dilivery/box.svg" />
                THÔNG TIN GÓI HÀNG
              </div>
              <div>
                <label class="lb">Khối lượng</label>
                <div class="relative">
                  <number v-model.number="dloInfoTmp.packageInfo.weightInKilo" v-bind="numFormat" 
                  @change="callChangeDataAppCode" placeholder="Khối lượng"
                  @keydown.native="enterKeyMinus($event)"
                  class="input-dilivery mb-0" :class="{'_errors': arrErrors.weightInKilo}" />
                  <div class="absolute">kg</div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-4">
                    <label class="lb">Dài</label>
                    <div class="relative">
                      <number v-model.number="dloInfoTmp.packageInfo.lengthInCentimeter" v-bind="numFormat" 
                      @change="callChangeDataAppCode" placeholder="Dài"
                      @keydown.native="enterKeyMinus($event)" 
                      class="input-dilivery mb-0"  />
                      <div class="absolute">cm</div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="lb">Rộng</label>
                    <div class="relative">
                      <number v-model.number="dloInfoTmp.packageInfo.widthInCentimeter" v-bind="numFormat" 
                      @change="callChangeDataAppCode" placeholder="Rộng" 
                      @keydown.native="enterKeyMinus($event)"
                      class="input-dilivery mb-0"  />
                      <div class="absolute">cm</div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="lb">Cao</label>
                    <div class="relative">
                      <number v-model.number="dloInfoTmp.packageInfo.heightInCentimeter" v-bind="numFormat" 
                      @change="callChangeDataAppCode" placeholder="Cao" 
                      @keydown.native="enterKeyMinus($event)"
                      class="input-dilivery mb-0"  />
                      <div class="absolute">cm</div>
                    </div>
                  </div>
                </div>
                <div class="relative mt-2">
                  <textarea v-model="dloInfoTmp.note" rows="3" placeholder="Nhập ghi chú cho gói hàng" class="input-dilivery mb-0 w-100"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8" style="border-left: 1px solid #F2F3F4;">
            <div class="title-dilivery">PHƯƠNG THỨC GIAO HÀNG</div>
            <div class="row">
              <div class="col-md-6">
                <label class="box-choise-dilivery" @click="clickChoiseDilivery('DELIVERY_PRIVATE_SHIPPER', 'active')" :class="{'act' : dloInfoTmp.targetService == 'DELIVERY_PRIVATE_SHIPPER'}">
                  <input type="radio" name="radio-dilivery-ship" :checked="dloInfoTmp.targetService == 'DELIVERY_PRIVATE_SHIPPER'">
                  <img src="@/assets/images/icon-dilivery/icon-wrap-0.svg">
                  Tự gọi shipper
                </label>
              </div>
              <div class="col-md-6">
                <label class="box-choise-dilivery" @click="clickChoiseDilivery('DELIVERY_PARTNER', 'active')" :class="{'act' : dloInfoTmp.targetService == 'DELIVERY_PARTNER'}">
                  <input type="radio" name="radio-dilivery-ship" :checked="dloInfoTmp.targetService == 'DELIVERY_PARTNER'">
                  <img src="@/assets/images/icon-dilivery/icon-wrap-1.svg">
                  Đẩy qua hãng vận chuyển
                </label>
              </div>
            </div>
            <div class="box-list-dilivery" v-if="dloInfoTmp.targetService == 'DELIVERY_PARTNER'">
              <div class="arr-list-dilivery" v-loading="load" :class="{'_errors': arrErrors.appCode}">
                <div class="title-list-dilivery">
                  <span class="pull-left">Dịch vụ</span>
                  <span class="pull-right">Phí dự kiến</span>
                </div>
                <div class="box-line-dilivery">
                  <div class="item-one-dilivery" v-for="(item, index) in dloInfoTmp.listPartnerDilivery" :key="index">
                    <div v-loading="loadItem">
                      <div class="top-one-dilivery" v-if="item.linked && !item.integrateInfo.expired" @click="clickOneDilivery(item.appCode)">
                        <img :src="item.logo">
                        <span class="name-dilivery">{{item.fullName}}</span>
                        <i class="fa fa-chevron-down"></i>
                      </div>  
                      <div class="top-one-dilivery" v-else>
                        <img :src="item.logo">
                        <span class="name-dilivery">{{item.fullName}}</span>
                        <a href="/partners" class="btn btn-default-ext text-primary">Liên kết ngay</a>
                      </div>
                      <div class="bottom-one-dilivery" v-if="item.linked && !item.integrateInfo.expired">
                        <label class="one-type-dilivery"  v-for="(val, idx) in dloInfoTmp.listPackagesDilivery" :key="idx">
                          <input type="radio" name="radio-dilivery" @click="getDeliveryServicePack(item, val)" :checked="dloInfoTmp.deliveryServicePack.packageInfo.id == val.id">
                          <span class="type-dilivery">{{val.name}}</span>
                          <span class="price-dilivery">{{formatMoneyNotUnitExt(dissociationThousand(val.amount))}}đ</span>
                        </label>
                      </div>
                    </div>
                    <div class="box-overlay-load" v-if="changeDataAppCode">
                      <div class="overlay-load">
                        <button class="btn btn-primary btn-sm" @click="clickOneDiliveryUpdate">
                          <img class="icon-loading" src="@/assets/images/icon-dilivery/icon-sync-alt.svg"> 
                          Cập nhật giá
                        </button>
                      </div>
                    </div> 
                  </div>
                  <div class="item-one-dilivery">
                    <div class="top-one-dilivery">
                      <img src="@/assets/images/icon-dilivery/grab.svg">
                      <span class="name-dilivery">Grab Express</span>
                      <button class="btn btn-default-ext">Sắp ra mắt</button>
                    </div>
                  </div>
                  <div class="item-one-dilivery">
                    <div class="top-one-dilivery">
                      <img src="@/assets/images/icon-dilivery/ghtk.svg">
                      <span class="name-dilivery">Giao hàng tiết kiệm</span>
                      <button class="btn btn-default-ext">Sắp ra mắt</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="title-dilivery mt-2">THÔNG TIN CHI TIẾT</div>
            <div class="mb-3">
              <div>Shipper <span class="text-danger">*</span></div>
              <div>
                <div class="box-shipper-right">
                  <div class="d-flex justify-content-between box-search-shipper-right">
                    <input v-model="dloInfoTmp.shipperInfo.text" @keyup="getListShippersDebounce" placeholder="Shipper mặc định" class="input-search-shipper-right text-primary ext">
                    <span class="text-bold">
                      <el-button class="border-0" style="background-color: #fff">
                        <b class="fz-18 text-black-50"><i class='fa fa-angle-down'></i></b>
                      </el-button>
                    </span>
                  </div>
                  <div class="box-show-shipper-right">
                    <div class="wrap-box-show-shipper-right">
                      <div @click="modalAddShipperNew = true" class="add-choise-shipper">
                        <span class="btn-add-info"><b class="bx bx-plus text-primary fz-18"></b></span>
                        <span class="text-primary font-weight-bold fz-14">
                          Thêm mới shipper
                        </span>
                      </div>
                      <div v-if="listShipper.length > 0">
                        <div class="item-shipper-choise" v-for="item in listShipper" :key="item.id">
                          <div class="itemShipper">
                            <div @click="clickOneShipper(item)">
                              <div>{{ item.name }}</div>
                              <div>{{ item.phoneNo }}</div>
                            </div>
                            <span class="itemShipperUpdate" @click="clickShipperUpdatePopup(item)">Sửa</span>	
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div>Phí trả đối tác giao hàng</div>
                <div>
                  <number v-model.number="dloInfoTmp.shippingFee" v-bind="numFormat" placeholder="VD: 20.000" 
                  @keydown.native="enterKeyMinus($event)"
                  class="input-dilivery"/>  
                </div>
              </div>
              <div class="col-md-6">
                <div> Phí ship báo khách</div>
                <div class="relative">
                  <number v-model.number="dloInfoTmp.addFeesShipping.amount" :disabled="disabledFeeShip" v-bind="numFormat" placeholder="VD: 20.000" 
                  @keydown.native="enterKeyMinus($event)"
                  class="input-dilivery"/>
                  <el-tooltip v-if="disabledFeeShip" class="item" effect="dark" content="Không sửa được do khách đã thanh toán số tiền này trong đơn hàng." placement="bottom-end">
                    <img class="icon_more_info" src="@assets/order-icon/more-info.svg" alt="more-info" />
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div class="input-note-dilivery">
              <div>Lưu ý:</div>
              <div>
                <ul>
                  <li>Phí ship báo khách sẽ không tương đồng với phí trả ĐTGH.</li>
                  <li>Phí ship báo khách sẽ được cộng vào tổng tiền đơn hàng và được tính vào doanh thu của cửa hàng.</li>
                  <li>Nếu người trả phí là cửa hàng, phí trả ĐTGH sẽ được tính là một khoản giảm trừ doanh thu và được tính vào các loại báo cáo.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="hr-solid" />
      <div class="row modal-dilivery-btns">
          <div class="text-right w-100">
            <button class="btn btn-default text-primary" @click="$emit('clickModalDiliveryHide')">Thoát</button>
            <button class="btn btn-primary" @click="clickConfirmDilivery">Xác nhận</button>
          </div>
      </div>
    </b-modal>
    <!--Them moi shipper-->
    <b-modal v-if="modalAddShipperNew" v-model="modalAddShipperNew" size="md" centered hide-header hide-footer no-close-on-backdrop id="modalAddShipperNew">
      <div class="head-popup-payment-method mb-0">
        <button type="button" aria-label="Close" class="close close-ext font-weight-light" @click="modalAddShipperNewHide">×</button>
        <div class="text-title-modal text-bold fz-18">Thêm mới shipper</div>
      </div>
      <div class="content-popup-dilivery-method">
        <el-form label-position="top" :model="ruleFormShipper" :rules="rules" ref="ruleFormShipper" label-width="120px"
				class="ruleFormShipper">
          <el-form-item label="Họ và tên" prop="name">
            <el-input v-model="ruleFormShipper.name"></el-input>
          </el-form-item>
          <el-form-item label="Số điện thoại" prop="phone">
            <el-input v-model="ruleFormShipper.phoneNo"></el-input>
          </el-form-item>
          <div class="mb-1 text-right">
            <el-button class="btn-default" @click="modalAddShipperNewHide">Thoát</el-button>
            <el-button type="primary" @click="submitFormShipper('ruleFormShipper')" :disabled="!checkValid">Hoàn tất</el-button>
          </div>
			</el-form>
      </div>
    </b-modal>
		<!--Cập nhật shipper-->
    <b-modal v-if="modalAddShipperUpdate" v-model="modalAddShipperUpdate" size="md" centered hide-header hide-footer no-close-on-backdrop id="modalAddShipperUpdate">
      <div class="head-popup-payment-method mb-0">
        <button type="button" aria-label="Close" class="close close-ext font-weight-light" @click="modalAddShipperUpdate=false">×</button>
        <div class="text-title-modal text-bold fz-18">Cập nhật shipper</div>
      </div>
      <div class="content-popup-dilivery-method">
        <el-form label-position="top" :model="itemShipperUpdate" :rules="rules" ref="itemShipperUpdate" label-width="120px"
          class="viewItemShipperUpdate">
          <el-form-item label="Họ và tên" prop="name">
            <el-input v-model="itemShipperUpdate.name"></el-input>
          </el-form-item>
          <el-form-item label="Số điện thoại" prop="phone">
            <el-input v-model="itemShipperUpdate.phoneNo"></el-input>
          </el-form-item>
          <div  class="mb-1" style="display:inline-block; width:100%">
            <el-button class="btn-red pull-left" @click="modalRemoveShipper=true">Xóa</el-button>
            <el-button type="primary" class="pull-right" @click="submitFormShipperUpdate('itemShipperUpdate')">Hoàn tất</el-button>
            <el-button class="btn-default pull-right" @click="modalAddShipperUpdate=false">Thoát</el-button>
          </div>
        </el-form>
      </div>
    </b-modal>
    <!--Xóa shipper-->
		<el-dialog title="Xoá thông tin shipper" v-if="modalRemoveShipper" :visible.sync="modalRemoveShipper" id="modalShipperRemove" width="500px"
			@close="modalRemoveShipper=false">
			<div class="line text-center">
				<div class="mt-2">
				<img src="@/assets/images/customer-nope.svg" />
				</div>
				<div class="mt-2">
					Bạn chắc chắn muốn xoá shipper “{{itemShipperUpdate.name}}”?<br>
					Bạn sẽ mất toàn bộ thông tin liên lạc, công nợ của người này.
				</div>
			</div>
			<div class="line mt-4 bdt-btn-action">
				<div class="padd5">
					<button @click="confirmRemoveShipper" type="button" class="btn btn-default btn-red pull-right">Xác nhận xoá</button>  
					<button type="button" class="btn btn-default text-primary pull-right" @click="modalRemoveShipper=false">Thoát</button>
				</div>
			</div>
		</el-dialog>
  </section>
</template>
<script>
import { mapMutations } from "vuex"
import {getListCity, getListDistrict, getListWard, removeVietnameseTonesAndToLowerCase} from "@/utils/address"
import { CustomerServices } from "@/services/nextshop/customer.service"
import { getStorageItem} from '@/utils/auth'
import { LocationService } from "@/services/nextshop/location.service"
import { showMess, numFormat } from "../utils/pos"
import _ from "lodash"
import { DiliveryServices } from "@/services/nextshop/dilivery.service"
import { ShipperServices } from '@/services/nextshop/shipper.service'
import dissociationThousand from "../mixins/pos"
import enterKeyMinus from "../mixins/pos"

export default {
  name: "Dilivery",
  props: {
    modalDilivery: {
      type: Boolean
    },
    disabledFeeShip: {
      type: Boolean,
      default: false
    },
    dloData: {
      type: Object,
      default: () => {return {}}
    },
    partyB: {
      type: Object,
      default: () => {return {}}
    }
  },
  mixins: [
    dissociationThousand,
    enterKeyMinus
  ],
  data() {
    return {
      rules: {
				name: [
					{ required: true, message: 'Họ và tên không được để trống', trigger: 'blur' },
					{ min: 1, max: 255, message: 'Họ và tên không quá 255 ký tự', trigger: 'blur' }
				],
				phoneNo: [
					{ required: true, message: 'Số điện thoại không được để trống', trigger: 'blur' },
					{ pattern: /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/, message: 'Số điện thoại không hợp lệ', trigger: 'blur' },
					{ min: 1, max: 15, message: 'Số điện thoại không quá 15 kí tự', trigger: 'blur' }
				]
			},
      listCity: [],
      listCityFilter: [],
      listDistrict: [],
      listDistrictFilter: [],
      listWard: [],
      listWardFilter: [],
      listShipper: [],
      modalAddShipperNew:false,
      modalAddShipperUpdate: false,
      ruleFormShipper: {
        name: '',
        phone: ''
      },
      itemShipperUpdate:{
        name: '',
        phone: ''
      },
      modalRemoveShipper:false,
      inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
      load: false,
      loadItem:false,
      appCode: '',
      appPackage: '',
      arrErrors:{
        receiverName: null,
        phoneNo: null,
        city: false,
        district: false,
        village: false,
        address: null,
        appCode: false,
        weightInKilo:false,
        cod: false
      },
      changeDataAppCode: false,
      numFormat: numFormat,
      dloInfoTmp: {}
    }
  },
  async created(){
    this.SET_LOADING(true)
    this.listCity = await getListCity()
    await this.getDataInit()
    await this.getDefaultShippers()
    this.SET_LOADING(false)
    this.getAllListAddress(this.dloInfoTmp.shippingAddress.city, this.dloInfoTmp.shippingAddress.district)
  },
  methods: {
    ...mapMutations("sell", ["SET_LOADING"]),
    checkIsEmpty(){
      return _.isEmpty(this.dloInfoTmp)
    },
    async getDataInit() {
      const locationId = getStorageItem('LID')
      try {
        this.dloInfoTmp = _.cloneDeep(this.dloData)

        this.appCode = this.dloInfoTmp.appCode
        this.appPackage = this.dloInfoTmp.appPackage
        // console.log(this.partyB)
        if(!_.isEmpty(this.partyB)) {
          if(this.dloInfoTmp.shippingAddress.phoneNo == '' || this.dloInfoTmp.shippingAddress.phoneNo == null){
            this.dloInfoTmp.shippingAddress.phoneNo = (this.partyB.phoneNo) ? this.partyB.phoneNo : null
          }
          if(this.dloInfoTmp.shippingAddress.receiverId == '' || this.dloInfoTmp.shippingAddress.receiverId == null){
            this.dloInfoTmp.shippingAddress.receiverId = (this.partyB.resId) ? this.partyB.resId : null
          }
          if(this.dloInfoTmp.shippingAddress.receiverName == '' || this.dloInfoTmp.shippingAddress.receiverName == null){
            this.dloInfoTmp.shippingAddress.receiverName = (this.partyB.displayName) ? this.partyB.displayName : null
          }
          if(this.dloInfoTmp.shippingAddress.address == '' || this.dloInfoTmp.shippingAddress.address == null){
            this.dloInfoTmp.shippingAddress.address = (this.partyB.address) ? this.partyB.address : null
          }
        }
       
        if (locationId !== '') {
          const response = await LocationService.getDetailLocation({ locationId: locationId })
          if (response.success) {
            const dataLocation = response.data
            this.dloInfoTmp.pickUpAddress.storeName = dataLocation.name ? dataLocation.name : null
            this.dloInfoTmp.pickUpAddress.address = dataLocation.address ? dataLocation.address : null
            this.dloInfoTmp.pickUpAddress.lat = dataLocation.latitude ? dataLocation.latitude : null
            this.dloInfoTmp.pickUpAddress.lng = dataLocation.longitude ? dataLocation.longitude : null
            this.dloInfoTmp.pickUpAddress.city = dataLocation.provinceCode ? dataLocation.provinceCode : null
            this.dloInfoTmp.pickUpAddress.cityName = dataLocation.province ? dataLocation.province : null
            this.dloInfoTmp.pickUpAddress.district = dataLocation.districtCode ? dataLocation.districtCode : null
            this.dloInfoTmp.pickUpAddress.districtName = dataLocation.district ? dataLocation.district : null
            this.dloInfoTmp.pickUpAddress.village = dataLocation.wardCode ? dataLocation.wardCode : null
            this.dloInfoTmp.pickUpAddress.villageName = dataLocation.ward ? dataLocation.ward : null
            this.dloInfoTmp.pickUpAddress.phoneNo = dataLocation.phoneNo ? dataLocation.phoneNo : null
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAllListAddress(cityCode, districtCode) {
      cityCode ? this.listDistrict = await getListDistrict(cityCode) : null;
      cityCode && districtCode ? this.listWard = await getListWard(cityCode, districtCode) : null ;
    },
    async getListDistrictHere() {
      this.listDistrict = [];
      this.dloInfoTmp.shippingAddress.district = null
      this.dloInfoTmp.shippingAddress.village = null
      this.listDistrict = await getListDistrict(this.dloInfoTmp.shippingAddress.city)
      
      const cityIndex = this.listCity.findIndex(e => e.id === this.dloInfoTmp.shippingAddress.city)
      if(cityIndex > -1){
        this.dloInfoTmp.shippingAddress.cityName = this.listCity[cityIndex].text
      }
      this.$refs.districtRef.focus()
      this.callChangeDataAppCode()
    },
    async getListWardHere() {
      this.listWard = [];
      this.dloInfoTmp.shippingAddress.village = null
      const cityCode = this.dloInfoTmp.shippingAddress.city
      const districtCode = this.dloInfoTmp.shippingAddress.district
      this.listWard = await getListWard(cityCode, districtCode)

      const districtIndex = this.listDistrict.findIndex(e => e.id === this.dloInfoTmp.shippingAddress.district)
      if(districtIndex > -1){
        this.dloInfoTmp.shippingAddress.districtName = this.listDistrict[districtIndex].text
      }

      this.$refs.wardRef.focus()
      this.callChangeDataAppCode()
    },
    changeWardHere(){
      const wardIndex = this.listWard.findIndex(e => e.id === this.dloInfoTmp.shippingAddress.village)
      if(wardIndex > -1){
        this.dloInfoTmp.shippingAddress.villageName = this.listWard[wardIndex].text
      }
    },
    async getValWard(){
      this.callChangeDataAppCode()
    },
    async getDefaultShippers(){
      if(this.dloInfoTmp.shipperInfo.id == '' || this.dloInfoTmp.shipperInfo.id == null){
        const response = await CustomerServices.getShipperDefault();
        if(response.success){
          if(response.data.id){
            this.dloInfoTmp.shipperInfo = {
              id: response.data.id,
              name: response.data.name,
              phoneNo: response.data.phoneNo,
              text: response.data.name + " - " + response.data.phoneNo
            }
          }
        }
      }
		},
    getListShippersDebounce: _.debounce(
      function() {
          this.getListShippers()
      }, 300),    
    async getListShippers() {
      const params = {
        "textSearch": this.dloInfoTmp.shipperInfo.text,
        "typePartner": "SHIPPER",
        "pageNum": 1,
        "pageSize": 20,
        "sortBy": "_id",
        "sortType": "DESC"
      }
      const response = await CustomerServices.getListCustomerPagging(params);
			if(response.success){
				this.listShipper = []
				response.data.data.map((e) => {
					const tmp ={
						...e,
						text: e.name + " - " + e.phoneNo
					}
					this.listShipper.push(tmp)
				})
			}
		},
    clickOneShipper(item){
      this.dloInfoTmp.shipperInfo = {
          id: item.id,
          name: item.name,
          phoneNo: item.phoneNo,
          text: item.text
        }
    },
    async clickChoiseDilivery(value, type){
      if(type == 'active'){
        this.dloInfoTmp.targetService = value
        if(value == 'DELIVERY_PARTNER'){
          await this.getPartnerDilivery()
        }else{
          this.appCode == ''
          this.appPackage == ''
        }
      }
    },
    modalAddShipperNewHide(){
			this.ruleFormShipper = {name : '', phone: ''}
			this.modalAddShipperNew = false
		},
    async submitFormShipper() {
			this.$refs.ruleFormShipper.validate(async(valid) => {
				if (valid) {
          this.modalAddShipperNew = false
					await this.quickAddShipper()
				} else {
					return false;
				}
			});
		},
    async quickAddShipper(){
			try {
        const params = {
          merchantId: this.inforAccount.merchantId,
          isPerson: true,
          name: this.ruleFormShipper.name,
          phoneNo: this.ruleFormShipper.phoneNo
        };
        const data = await ShipperServices.createNewShipper(params)
        if (data.success) {
					this.oneShipper = {
            ...data.data,
            text: data.data.name + " - " + data.data.phoneNo
          }
          this.listShipper.push(this.oneShipper)
          this.dloInfoTmp.shipperInfo = {
						id: data.data.id,
						name: data.data.name,
						phoneNo: data.data.phoneNo,
						text: data.data.name + " - " + data.data.phoneNo
					}
				}else{
          showMess(this, 'Thông báo', 'Lỗi thêm mới shipper!', 'danger', 'b-toaster-top-right', 1000)
          return false
				}
			} catch (error) {
				console.log(error);
			}
		},
    clickShipperUpdatePopup(item){
      this.itemShipperUpdate = item
			this.modalAddShipperUpdate = true
    },
    async submitFormShipperUpdate() {
			this.$refs.itemShipperUpdate.validate(async(valid) => {
				if (valid) {
					this.modalAddShipperUpdate = false
					await this.quickUpdateShipper()
				} else {
					return false;
				}
			});
		},
    async quickUpdateShipper() {
			try {
				const params = {
          id: this.itemShipperUpdate.id,
          param:{
            name: this.itemShipperUpdate.name,
            phoneNo: this.itemShipperUpdate.phoneNo,
            merchantId: this.inforAccount.merchantId,
            version: this.itemShipperUpdate.version,
            id: this.itemShipperUpdate.id,
            isPerson: true
          }
				}
				const data = await ShipperServices.updateShipperv2(params);
				if (data.success) {
					this.dloInfoTmp.shipperInfo = {
						id: data.data.id,
						name: data.data.name,
						phoneNo: data.data.phoneNo,
						text: data.data.name + " - " + data.data.phoneNo
					}
				}else{
					alert('Lỗi cập nhật shipper')
				}
			} catch (error) {
				console.log(error);
			}
		},
    async clickConfirmDilivery(){
      const checkErs = await this.checkErrors()
      if (!checkErs) { return false }

      this.$emit("new-dlo-info", this.dloInfoTmp)
      this.$emit('clickModalDiliveryHide')
      return false
    },
    async confirmRemoveShipper(){
			try {
				const shipperId= this.itemShipperUpdate.id
				const data = await ShipperServices.removeShipper(shipperId)
				if (data.success) {
					this.modalRemoveShipper = false
					this.modalAddShipperUpdate = false

					if(this.dloInfoTmp.shipperInfo.id == this.itemShipperUpdate.id){
						this.dloInfoTmp.shipperInfo = {id: null,name: null,phoneNo: null,text: null}
            this.itemShipperUpdate = {name: '', phone: ''}
					}
					this.listShipper = []
				}
			} catch (error) {
				console.log(error);
			}
		},
    async checkErrors(){
      let valid = true
      
      //Dia chi nhan hang
      if(this.dloInfoTmp.pickUpAddress.address == '' || this.dloInfoTmp.pickUpAddress.address == null){
        valid = false
      }
      if(this.dloInfoTmp.pickUpAddress.cityName == '' || this.dloInfoTmp.pickUpAddress.cityName == null){
        valid = false
      }
      if(this.dloInfoTmp.pickUpAddress.districtName == '' || this.dloInfoTmp.pickUpAddress.districtName == null){
        valid = false
      }
      if(this.dloInfoTmp.pickUpAddress.villageName == '' || this.dloInfoTmp.pickUpAddress.villageName == null){
        valid = false
      }

      if(!valid){
        showMess(this, 'Thiếu địa chỉ hoặc số điện thoại chi nhánh', 'Vui lòng vào mục “Quản lý chi nhánh” trong Cấu hình để bổ sung thông tin.', 'danger', 'b-toaster-top-right', 1000)
      }
      
      //Dia chi giao hang  
      if(this.dloInfoTmp.shippingAddress.address == '' || this.dloInfoTmp.shippingAddress.address == null){
        valid = false
        this.arrErrors.address = true
      }else{
        this.arrErrors.address = false
      }
      if(this.dloInfoTmp.shippingAddress.receiverName == '' || this.dloInfoTmp.shippingAddress.receiverName == null){
        valid = false
        this.arrErrors.receiverName = true
      }else{
        this.arrErrors.receiverName = false
      }
      if(this.dloInfoTmp.shippingAddress.phoneNo == '' || this.dloInfoTmp.shippingAddress.phoneNo == null){
        valid = false
        this.arrErrors.phoneNo = true
      }else{
        this.arrErrors.phoneNo = false
      }
    
      //Thong tin shipper
      if(this.dloInfoTmp.targetService == 'DELIVERY_PRIVATE_SHIPPER'){
        if(this.dloInfoTmp.shipperInfo.id == '' || this.dloInfoTmp.shipperInfo.id == null){
          valid = false
        }
        if(this.dloInfoTmp.shipperInfo.name == '' || this.dloInfoTmp.shipperInfo.name == null){
          valid = false
        }
        if(this.dloInfoTmp.shipperInfo.phoneNo == '' || this.dloInfoTmp.shipperInfo.phoneNo == null){
          valid = false
        }
      }
    
      //Don vi van chuyen
      if(this.dloInfoTmp.targetService == 'DELIVERY_PARTNER'){
        if(this.appCode == '' || this.appCode == null){
          valid = false
          this.arrErrors.appCode = true
        }else{
          this.arrErrors.appCode = false
        }
        if(this.appPackage == '' || this.appPackage == null){
          valid = false
          this.arrErrors.appCode = true
        }else{
          this.arrErrors.appCode = false
        }
        
        if(this.dloInfoTmp.shippingAddress.city == '' || this.dloInfoTmp.shippingAddress.city == null){
          valid = false
          this.arrErrors.city = true
          this.dloInfoTmp.shippingAddress.district = null
          this.dloInfoTmp.shippingAddress.village = null
        }else{
          this.arrErrors.city = false
        }
        if(this.dloInfoTmp.shippingAddress.district == '' || this.dloInfoTmp.shippingAddress.district == null){
          valid = false
          this.arrErrors.district = true
          this.dloInfoTmp.shippingAddress.village = null
        }else{
          this.arrErrors.district = false
        }
        if(this.dloInfoTmp.shippingAddress.village == '' || this.dloInfoTmp.shippingAddress.village == null){
          valid = false
          this.arrErrors.village = true
        }else{
          this.arrErrors.village = false
        }

        if(this.dloInfoTmp.packageInfo.weightInKilo > 100){
          valid = false
          this.arrErrors.weightInKilo = true
        }else{
          this.arrErrors.weightInKilo = false
        }

        const _cod = this.checkNumReplaceComma(this.dloInfoTmp.cod)
        if(_cod > 3000000){
          valid = false
          this.arrErrors.cod = true
        }else{
          this.arrErrors.cod = false
        }
      }
      
      if(!valid){
        showMess(this, 'Thông báo', 'Vui lòng nhập đủ thông tin địa chỉ giao hàng và phương thức giao hàng!', 'danger', 'b-toaster-top-right', 1000)
      }
      
      return valid
    },
    async getAllPartnerDilivery(){
      this.load = true
      const response = await DiliveryServices.getListDilivery('DELIVERY')
      this.dloInfoTmp.listPartnerDilivery = []
      if(response.success){
        response.data.map((e)=>{
          const tmpItem = {
            ...e.appInfo,
            linked:e.linked,
            integrateInfo:e.integrateInfo
          }
          this.dloInfoTmp.listPartnerDilivery.push(tmpItem)
        })
      }
      this.load = false
    },
    getPartnerDilivery: _.debounce(
      async function() {
        await this.getAllPartnerDilivery() 
    }, 1000),

    async clickOneDilivery(appCode){
      if(appCode != '' && 
        this.dloInfoTmp.pickUpAddress.cityName != '' &&  
        this.dloInfoTmp.pickUpAddress.districtName != '' &&  
        this.dloInfoTmp.pickUpAddress.villageName != '' &&  
        this.dloInfoTmp.pickUpAddress.address !== null && 
        this.dloInfoTmp.pickUpAddress.address !== '' && 
        this.dloInfoTmp.pickUpAddress.phoneNo !== '' && 
        this.dloInfoTmp.shippingAddress.city !== null &&
        this.dloInfoTmp.shippingAddress.district != null &&
        this.dloInfoTmp.shippingAddress.village != null &&
        this.dloInfoTmp.shippingAddress.address !== null && 
        this.dloInfoTmp.shippingAddress.address != '' &&
        this.dloInfoTmp.shippingAddress.phoneNo != null &&
        this.dloInfoTmp.shippingAddress.phoneNo != '' &&
        this.dloInfoTmp.shippingAddress.receiverName != null &&
        this.dloInfoTmp.shippingAddress.receiverName != ''
      ){
        this.loadItem = true
        this.appCode = appCode
        this.dloInfoTmp.appCode = appCode

        if(this.dloInfoTmp.packageInfo.weightInKilo > 100){
          showMess(this, 'Thông báo', 'Lỗi từ HeyU: 400: Giá trị cân nặng đơn hàng phải nằm trong khoảng 0 - 100 KG', 'danger', 'b-toaster-top-right', 1000)
          this.loadItem = false
          this.arrErrors.weightInKilo = true
          return false
        }else{
          this.arrErrors.weightInKilo = false
        }

        const _cod = this.checkNumReplaceComma(this.dloInfoTmp.cod)
        if(_cod > 3000000){
          showMess(this, 'Thông báo', 'Lỗi từ HeyU: 400: Tiền ứng phải nằm trong khoảng giá trị từ 0 đến 3.000.000', 'danger', 'b-toaster-top-right', 1000)
          this.loadItem = false
          this.arrErrors.cod = true
          return false
        }else{
          this.arrErrors.cod = false
        }
        
        const params = {
          cod: this.dloInfoTmp.cod,
          packageInfo: {
            heightInCentimeter: this.dloInfoTmp.packageInfo.heightInCentimeter,
            lengthInCentimeter: this.dloInfoTmp.packageInfo.lengthInCentimeter,
            weightInKilo: this.dloInfoTmp.packageInfo.weightInKilo,
            widthInCentimeter: this.dloInfoTmp.packageInfo.widthInCentimeter
          },
          pickUpAddress: {
            address: this.dloInfoTmp.pickUpAddress.address,
            cityName: this.dloInfoTmp.pickUpAddress.cityName,
            districtName: this.dloInfoTmp.pickUpAddress.districtName,
            villageName: this.dloInfoTmp.pickUpAddress.villageName,
            phoneNo: this.dloInfoTmp.pickUpAddress.phoneNo
          },
          shippingAddress: {
            address: this.dloInfoTmp.shippingAddress.address,
            city: this.dloInfoTmp.shippingAddress.city,
            cityName: this.dloInfoTmp.shippingAddress.cityName,
            district: this.dloInfoTmp.shippingAddress.district,
            districtName: this.dloInfoTmp.shippingAddress.districtName,
            village: this.dloInfoTmp.shippingAddress.village,
            villageName: this.dloInfoTmp.shippingAddress.villageName,
            phoneNo: this.dloInfoTmp.shippingAddress.phoneNo,
            receiverName: this.dloInfoTmp.shippingAddress.receiverName
          }
        }
       
        try {
          const response = await DiliveryServices.checkPackageDilivery(params, appCode)
          this.loadItem = false
          if(response.success){
            this.dloInfoTmp.listPackagesDilivery = (response.data.packages.length > 0) ? response.data.packages : []
          }
        } catch (e) {
          if(e.response.data.code == 'HEYU_ERROR'){
            showMess(this, 'Thông báo', e.response.data.message, 'danger', 'b-toaster-top-right', 1000)
          }else{
            showMess(this, 'Thiếu địa chỉ hoặc số điện thoại chi nhánh', 'Vui lòng vào mục “Quản lý chi nhánh” trong Cấu hình để bổ sung thông tin.', 'danger', 'b-toaster-top-right', 1000)
          }
          this.loadItem = false
        }
      }else{
        showMess(this, 'Thông báo', 'Vui lòng nhập đủ thông tin địa chỉ giao hàng!', 'danger', 'b-toaster-top-right', 1000)
        return false
      }
    },
    getDeliveryServicePack(item, val){
      this.dloInfoTmp.shippingFee = this.dissociationThousand(val.amount)
      this.dloInfoTmp.deliveryServicePack = {
        packageInfo: {
          id: val.id,
          name: val.name
        },
        partnerCode: item.appCode
      }
      this.appPackage = val.id
      this.dloInfoTmp.appPackage = val.id
    },
    async clickOneDiliveryUpdate(){
      if(this.appCode != ''){
        this.changeDataAppCode = false
        await this.clickOneDilivery(this.appCode)
      }
    },
    callChangeDataAppCode(){
      if(this.appCode != '' && this.appCode != null && this.dloInfoTmp.targetService == 'DELIVERY_PARTNER'){
        this.changeDataAppCode = true
      }
    },
    filterOption(query, parent, keyRaw, keyFilter) {
      const textSearch = removeVietnameseTonesAndToLowerCase(query.trim())
      if (!textSearch) {
        parent[keyFilter] = parent[keyRaw]
      } else {
        parent[keyFilter] = parent[keyRaw].filter(e => e.queryText.includes(textSearch))
      }
    }

  },
  watch: {
    listCity: {
      handler() {
        this.listCityFilter = this.listCity
      },
      immediate: true
    },
    listDistrict: {
      handler() {
        this.listDistrictFilter = this.listDistrict
      },
      immediate: true
    },
    listWard: {
      handler() {
        this.listWardFilter = this.listWard
      },
      immediate: true
    },
  },
  computed: {
    checkValid() {
      return this.checkErrors()
    },
  },
}
</script>
<style scoped lang="scss">
 ::v-deep .modal-body {
  padding: 0px !important;
}
.btn-default{
	border:none;
	background: none;
}
@media (min-width: 992px){
  ::v-deep .modal-lg,  ::v-deep .modal-xl {
    max-width: 67%;
  }
}
.icon_more_info {
  position: absolute;
  right: 10px;
  top: 12px;
}
.relative {
  position: relative;
}
.box-list-dilivery{
  width: 100%;
  display: inline-block;
  position: relative;
}
.arr-list-dilivery{
  position: absolute;
  min-height: 540px;
  width: 100%;
  display: inline-block;
  border: 1px solid #ddd;
  border-radius: 3px;
  top: 0;
  z-index: 9999;
  background: #fff;
}
.title-list-dilivery {
  background: #F2F3F4;
  display: inline-block;
  width: 100%;
  padding: 10px;
  font-weight: bold;
}
.item-one-dilivery{
  display: inline-block;
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #F2F3F4;
  position: relative;
  font-size: 14px;
}
.top-one-dilivery{
  position: relative;
  cursor: pointer;
}
.item-one-dilivery img{
  width: 40px;
  height: 40px;
  margin-right: 5px;
}
.top-one-dilivery i{
  position: absolute;
  right: 0;
  top: 18px;
  cursor: pointer;
}
.name-dilivery {
  display: inline-block;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  top: 8px;
  white-space: nowrap;
  font-weight: bold;
}
.bottom-one-dilivery {
  display: inline-block;
  width: 100%;
  margin-top: 5px;
}
.type-dilivery {
  display: inline-block;
  width: 80%;
  margin-left: 10px;
}
.price-dilivery {
  float: right;
}
.one-type-dilivery {
  padding: 10px 15px;
  display: inline-block;
  width: 100%;
  cursor: pointer;
  border-radius: 2px;
}
.one-type-dilivery:hover{
  background: #fafafa;
}
.top-one-dilivery .btn{
  position: absolute;
  right: 0;
  top: 2px;
  cursor: pointer;
  color: #BDC1C5;
  background: #F2F3F4;
}
.box-overlay-load{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: rgba(255, 255, 255, 0.5);
  top: 0;
  text-align: center;
}
.box-overlay-load .overlay-load {
  align-items: center;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  font-size: 14px;
}
.box-overlay-load .overlay-load .icon-loading{
  width: 28px;
  height: 28px;
  margin-right: 0;
}
.box-overlay-load .overlay-load .btn {
  font-size: 14px;
}
.top-one-dilivery a.btn-default-ext{
  position: absolute;
  right: 0;
}
::v-deep .errors .multiselect__tags{
  border: 2px solid #ff0000 !important;
}
._errors{
  border: 2px solid #ff0000 !important;
}
.lb{
  color: #808890;
}
</style>

